import ProgressBar from "./ProgressBar";
import withResponsiveUtils from "../../utils/ResponsiveUtils";

export default withResponsiveUtils(ProgressBar);
